import { MakerSchema } from 'src/models/maker/schema';
import { BackendApiFetch } from 'src/utils/backendApi';
import { errorMessage } from 'src/utils/errorMessage';

const fetchMakers = async (locale: string): Promise<MakerSchema[]> => {
  try {
    const makersResponse = await BackendApiFetch<MakerSchema[]>({
      path: '/app/v1/makers',
      localeType: locale,
    });
    const makers = makersResponse.data;
    return makers;
  } catch (e) {
    throw new Error(errorMessage(e));
  }
};

export { fetchMakers };
